import { createSlice } from '@reduxjs/toolkit';
export const navOnboardingTourHoverSliceName = 'navOnboardingTourHover';
export const initialNavOnboardingTourHoverState = {
  isHovered: false
};
export const {
  reducer: navOnboardingTourHoverReducer,
  actions: navOnboardingTourHoverActions
} = createSlice({
  name: navOnboardingTourHoverSliceName,
  initialState: initialNavOnboardingTourHoverState,
  reducers: {
    setIsHovered: (state, action) => {
      state.isHovered = action.payload;
    }
  }
});